import { render, staticRenderFns } from "./MealSchedule.vue?vue&type=template&id=2ef73f8e&"
import script from "./MealSchedule.vue?vue&type=script&lang=js&"
export * from "./MealSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports